export enum ExpirationPaymentStatus {
  Pending = 'pending',
  Paid = 'paid',
  Remitted = 'remitted',
  Returned = 'returned',
}

export const ExpirationPaymentStatuses: ExpirationPaymentStatus[] = [ExpirationPaymentStatus.Pending, ExpirationPaymentStatus.Paid, ExpirationPaymentStatus.Remitted, ExpirationPaymentStatus.Returned];
